import { InputActionTypes, InputState } from './inputTypes';

const INIT_STATE: InputState = {
  thought: '',
  mode: 'instant',
  isLoading: false,
  error: null,
};

const inputReducer = (state = INIT_STATE, action: any): InputState => {
  switch (action.type) {
    case InputActionTypes.SET_THOUGHT:
      return { ...state, thought: action.payload.thought };
    case InputActionTypes.SET_MODE:
      return { ...state, mode: action.payload.mode };
    case InputActionTypes.SET_LOADING:
      return { ...state, isLoading: action.payload.loading };
    case InputActionTypes.SET_ERROR:
      return { ...state, error: action.payload.error };
    case InputActionTypes.RESET:
      return INIT_STATE;
    default:
      return state;
  }
};

export default inputReducer;
